export const IMG = {
  cover: "https://customer-assets-rejwkqb3.emergentagent.net/job_discovery-lernen/artifacts/53jpjekc_Dein%20Abschnittstext%20-%201.webp",
  rot: "https://customer-assets-rejwkqb3.emergentagent.net/job_discovery-lernen/artifacts/nzee62xs_Dein%20Abschnittstext%20-%202.webp",
  blau: "https://customer-assets-rejwkqb3.emergentagent.net/job_discovery-lernen/artifacts/0pkw8q5c_Dein%20Abschnittstext%20-%203.webp",
  gelb: "https://customer-assets-rejwkqb3.emergentagent.net/job_discovery-lernen/artifacts/l7aczrc8_Dein%20Abschnittstext%20-%204.webp",
  gruen: "https://customer-assets-rejwkqb3.emergentagent.net/job_discovery-lernen/artifacts/31pjexki_Dein%20Abschnittstext%20-%205.webp",
  abschluss: "https://customer-assets-rejwkqb3.emergentagent.net/job_discovery-lernen/artifacts/9c1fokzl_Dein%20Abschnittstext%20-%2011.webp",
  moment: "https://static.prod-images.emergentagent.com/jobs/e65ef122-13b7-4ef7-81f6-488262bea165/images/082f78aaf429fb3addd836e29c201146bc4bd9b2146bcbd768bbee014b78744f.jpeg",
};

export const WORLDS = [
  {
    slug: "farben",
    title: "Kleine Welt, große Farben",
    short: "Farben",
    subtitle: "Farben sehen. Benennen. Mitsingen.",
    status: "available",
    statusLabel: "Jetzt erhältlich",
    age: "Ab 2 Jahren",
    accent: "#D95338",
    soft: "#FDF2EF",
    cover: IMG.cover,
    description:
      "Rot wie der Marienkäfer. Blau wie der Wal. Gelb wie das Küken. Kleine Welt, große Farben begleitet Kinder durch eine liebevoll gestaltete Welt der ersten Farben.",
    price: "14,90 €",
    packageName: "Das VisualMA Lernpaket",
    contents: [
      "VisualMA Mobile Edition (EPUB) – für Smartphone & Tablet",
      "VisualMA HQ & Print Edition (PDF) – für große Displays & privaten Ausdruck",
      "VisualMA Lernsong (MP3) – zum Hören, Mitsingen & Mitmachen",
      "Sofort nach dem Kauf verfügbar",
    ],
    pages: [
      { color: "Rot", hex: "#D95338", soft: "#F6E3DD", img: IMG.rot, animal: "der Marienkäfer", word: "Eine Farbe." },
      { color: "Blau", hex: "#3A7BD5", soft: "#E2EBF7", img: IMG.blau, animal: "der Wal", word: "Ein Tier." },
      { color: "Gelb", hex: "#E5A93C", soft: "#F8EEDA", img: IMG.gelb, animal: "das Küken", word: "Vertraute Motive." },
      { color: "Grün", hex: "#4A8B5D", soft: "#E4EEE7", img: IMG.gruen, animal: "der Frosch", word: "Klare Worte." },
    ],
    song: {
      title: "Kleine Welt, große Farben – VisualMA Lernsong",
      url: "https://customer-assets-rejwkqb3.emergentagent.net/job_discovery-lernen/artifacts/zxot8og3_Kleine%20Welt%2C%20gro%C3%9Fe%20Farben%20Lernprobe.mp3",
    },
  },
  {
    slug: "zahlen",
    title: "Kleine Welt, große Zahlen",
    short: "Zahlen",
    subtitle: "Erste Zahlen entdecken und mitzählen.",
    status: "next",
    statusLabel: "Kommt als Nächstes",
    age: "Ab 2 Jahren",
    accent: "#3A7BD5",
    soft: "#EEF4FC",
    cover: null,
    glyphs: ["1", "2", "3"],
    description:
      "Die nächste VisualMA Lernwelt widmet sich den ersten Zahlen – zum gemeinsamen Zählen, Zeigen und Mitsingen.",
  },
  {
    slug: "formen",
    title: "Kleine Welt, große Formen",
    short: "Formen",
    subtitle: "Kreise, Dreiecke und erste Formen.",
    status: "planned",
    statusLabel: "In Planung",
    age: "Ab 2 Jahren",
    accent: "#E5A93C",
    soft: "#FCF7EB",
    cover: null,
    glyphs: ["●", "▲", "■"],
    description:
      "Runde, eckige und spitze Entdeckungen: eine Lernwelt rund um erste Formen ist in Planung.",
  },
  {
    slug: "tiere",
    title: "Kleine Welt, große Tiere",
    short: "Tiere",
    subtitle: "Vertraute Tiere sehen und benennen.",
    status: "planned",
    statusLabel: "In Planung",
    age: "Ab 2 Jahren",
    accent: "#4A8B5D",
    soft: "#F0F6F2",
    cover: null,
    glyphs: ["◠", "◡", "●"],
    description:
      "Vom Marienkäfer bis zum Wal: eine eigene Lernwelt voller vertrauter Tiere ist in Planung.",
  },
];

export const FAQ_ITEMS = [
  {
    q: "Für welches Alter sind die VisualMA Lernwelten gedacht?",
    a: "Unsere ersten Lernwelten richten sich an Kinder ab etwa 2 Jahren und sind zum gemeinsamen Anschauen, Benennen, Mitsingen und Entdecken gedacht.",
  },
  {
    q: "Kann mein Kind das Buch alleine lesen?",
    a: "Die Lernbücher sind bewusst für gemeinsames Entdecken gestaltet. Erwachsene oder andere Bezugspersonen begleiten das Kind beim Anschauen, Benennen und Mitsingen.",
  },
  {
    q: "Was ist im digitalen Lernpaket enthalten?",
    a: "Das VisualMA Lernpaket enthält drei Dateien: die VisualMA Mobile Edition (EPUB für Smartphone & Tablet), die VisualMA HQ & Print Edition (hochauflösende PDF für große Displays und privaten Ausdruck) und den vollständigen VisualMA Lernsong als MP3.",
  },
  {
    q: "Wie erhalte ich meine Dateien?",
    a: "Nach erfolgreicher Zahlung stehen die digitalen Inhalte zum Download bereit.",
  },
  {
    q: "Gibt es die Bücher auch gedruckt?",
    a: "Eine physische VisualMA Ringbuch-Ausgabe befindet sich aktuell in Entwicklung.",
  },
  {
    q: "Werden weitere Lernwelten erscheinen?",
    a: "Ja. Nach Farben sind weitere VisualMA Lernwelten rund um Zahlen, Formen, Tiere und zusätzliche erste Lernthemen geplant.",
  },
];
